angular.module('cfn').service('search.service', searchService);

searchService.$inject = ['dataSource.factory', '$q'];

/**
 * source {string|string[]|dataSource} a data source or a string for a named dataSource (e.g. 'field')
 * options {Object} configurations object:
 * {
 *  customResourceExtend    {obj} extend angular resource object in dataSource factory (e.g. to attach url params or to define restAction)
 *  initOnFirstSearch       {boolean} if dataSource will be accessed on first search (if not it get isInitialized after buildIndex)
 */
function searchService(dataSource, $q) {
  return function(sources, options) {
    var thisService = null,
      opt = _.deepObjectExtend(
        {
          initOnFirstSearch: false,
          customResourceExtend: {
            query: {
              restAction: 'ActiveOnly' // per default query only activeonly (used for dataSource Factory)
            }
          }
        },
        options || {}
      ),
      initOnFulltextsearch = null,
      onReady = null,
      excludedIds = {},
      originalItemsList = {},
      isSingleRepo = false, //if we are using a single repository
      isInitialized = false,
      repos = {},
      buildIndexStore = [];

    init();

    // --- interface ----------------------------------------------------------------------------------------

    return (thisService = {
      buildIndex: buildIndex,
      excludeId: excludeFromIndex,
      removeExcludedId: undoExcludeFromIndex,
      excludeFromIndex: excludeFromIndex,
      undoExcludeFromIndex: undoExcludeFromIndex,
      clearExcludedItems: clearExcludedItems
    });

    // --- methods --------------------------------------------------------------------------------------------

    function init() {
      // reset promises
      if (onReady) onReady.reject();
      if (initOnFulltextsearch) initOnFulltextsearch.reject();

      initOnFulltextsearch = $q.defer();
      onReady = $q.defer();

      isInitialized = false;

      if (!opt.initOnFirstSearch) {
        //resolve the lazy initialization if not required
        initOnFulltextsearch.resolve();
      }

      if (angular.isArray(sources)) {
        isSingleRepo = false;
        for (var i in sources) {
          repos[sources[i]] = dataSource(sources[i]);
        }
      } else {
        isSingleRepo = true;
        if (typeof sources === 'string') {
          repos['default'] = dataSource(sources);
        } else {
          repos['default'] = sources;
        }
      }
    }

    function initData() {
      var def = $q.defer();

      initOnFulltextsearch.promise.then(function() {
        if (isInitialized) {
          return def.resolve();
        }

        var promises = getDataPromises();

        $q.all(promises).then(function() {
          isInitialized = true;
          def.resolve();
        });
      });
      return def.promise;
    }

    function getDataPromises() {
      var promises = [];

      _.each(repos, function(key, name) {
        var repoListPromise;

        repoListPromise = repos[name].getList(opt.customResourceExtend.query);
        repoListPromise.then(function(results) {
          storeoriginalItemsList(name, results);
        });

        promises.push(repoListPromise);
      });

      return promises;
    }

    function storeoriginalItemsList(name, results) {
      if (!angular.isArray(results)) {
        return console.error(
          'searchService cannot handle the results of this datasource: ',
          name,
          results
        );
      }

      originalItemsList[name] = {};

      _.each(results, function(item) {
        originalItemsList[name][item.id] = item;
      });
    }

    // --- public methods ----------------------------------------------------------------------------------------

    /**
     * Build the index of the underlying model data.
     * @param indexConfig {object} contains different index creators:
     *  fullText: function(elem) -> string := creates a string from the element for the full text search.
     */
    function buildIndex(indexConf) {
      var indexConfig = indexConf || {},
        fullTextIndex = {};

      initData().then(executeFulltextFunctions);

      function executeFulltextFunctions() {
        var fullTextIndexFn;
        if (angular.isFunction(indexConfig.fullText)) {
          fullTextIndexFn = { default: indexConfig.fullText };
        } else {
          fullTextIndexFn = indexConfig.fullText;
        }
        _.each(originalItemsList, function(values, sourceName) {
          _.each(values, function(elem) {
            var hasNoFulltextFnSpecified =
              !indexConfig.fullText && !fullTextIndexFn[sourceName];

            if (hasNoFulltextFnSpecified) {
              return;
            }

            var idxResult = fullTextIndexFn[sourceName](elem);
            if (!angular.isArray(idxResult)) {
              idxResult = [idxResult];
            }

            for (var i in idxResult) {
              if (idxResult.hasOwnProperty(i)) {
                createIndexFullText(sourceName, idxResult[i], elem);
              }
            }
          });
        });
        onReady.resolve();
      }

      var hyphenationCharacter = String.fromCharCode(173);
      function createIndexFullText(sourceName, fullText, item) {
        if (
          fullText === undefined ||
          fullText === null ||
          fullText.length === 0
        ) {
          return;
        }

        //simple phrase index, remove hyphenation character
        var text = fullText.toLowerCase().replace(hyphenationCharacter, '');
        if (fullTextIndex[text] === undefined) {
          fullTextIndex[text] = [];
        }
        fullTextIndex[text].push({ source: sourceName, item: item });
      }

      function iterateThroughIndex(searchQuery) {
        var results = {};
        var foundItems = {};
        //check if some entry is explicitly excluded
        var shouldBeExcluded = function(entry) {
          if (excludedIds['default'] && excludedIds['default'][entry.item.id])
            return true;
          return (
            entry.source !== 'default' &&
            excludedIds[entry.source] &&
            excludedIds[entry.source][entry.item.id]
          );
        };

        // add found Items to results
        _.each(fullTextIndex, function(indexItem, idxName) {
          var regexCompatString = searchQuery.replace(
              /([.*+?^=!:${}()|\[\]\/\\])/g,
              '\\$1'
            ),
            isQueryMatchingIndexItem = idxName.search(regexCompatString) > -1;

          if (!isQueryMatchingIndexItem) {
            return;
          }

          _.each(indexItem, function(entry) {
            //scan through every indexed string
            if (shouldBeExcluded(entry)) return;

            if (!results[entry.source]) {
              //first entry from this resource
              results[entry.source] = [];
              foundItems[entry.source] = {};
            }
            if (!foundItems[entry.source][entry.item.id]) {
              results[entry.source].push(entry.item);
              foundItems[entry.source][entry.item.id] = true;
            }
          });
        });

        if (opt.sortBy) {
          //make sure we have an array and it's reversed. This and the stable sorting of underscore
          //allows us to sort over multiple fields
          var sortBy = angular.isArray(opt.sortBy)
            ? opt.sortBy.slice().reverse()
            : [opt.sortBy];

          _.each(results, function(items, source) {
            var chain = _(items).chain();
            _.each(sortBy, function(sortItem) {
              chain = chain.sortBy(sortItem);
            });

            results[source] = chain.value();
          });
        }

        return results;
      }

      var indexInstance = {
        /**
         * @returns {searchService} link to the parent searchService
         */
        getSearchService: function() {
          return thisService;
        },
        /**
         * @param text text for the full text search
         * @returns {Object} search Result
         *      searchString: original search string
         *      results: array with matching items.
         */
        fullTextSearch: function(text) {
          //assure we get isInitialized (we might have deferred it until now)
          initOnFulltextsearch.resolve();
          var searchResult = $q.defer();
          onReady.promise.then(function() {
            var results = iterateThroughIndex(preprocessSearchString(text));

            //flatten results if we have a single repository
            if (isSingleRepo) {
              results = results.default || [];
            }

            if (indexConfig.handleResults) {
              results = indexConfig.handleResults(results);
            }

            searchResult.resolve({
              searchString: text,
              results: results
            });
          });
          return searchResult.promise;
        }
      };

      //indexes should always inherit from searchService (e.g. for excludedIds functionality, etc)
      return angular.extend(indexInstance, thisService);
    }

    /**
     * @param item - exclude item from result set
     * @returns {*} return the service or index object
     */

    function excludeFromIndex(id, sourceName) {
      var sourceName = sourceName || 'default';
      if (!excludedIds[sourceName]) excludedIds[sourceName] = {};
      excludedIds[sourceName][id] = true;
      return this;
    }

    function undoExcludeFromIndex(id, sourceName) {
      var sourceName = sourceName || 'default';
      if (excludedIds[sourceName]) delete excludedIds[sourceName][id];
      return this;
    }

    // --- helpers ------------------------------------------------------------------------------------------

    function preprocessSearchString(fullText) {
      return fullText.toLowerCase();
    }

    /**
     * Clear all excluded items so they can be used again.
     */
    function clearExcludedItems() {
      excludedIds = {};
    }
  };
}

export default searchService;
